const firebaseConfig = {
  apiKey: "AIzaSyArB8QvZTzFuo384xjRKC5K6U2BStGaeLE",
  authDomain: "doctor-care-auth.firebaseapp.com",
  projectId: "doctor-care-auth",
  storageBucket: "doctor-care-auth.appspot.com",
  messagingSenderId: "1026616711348",
  appId: "1:1026616711348:web:ec1af14243dcff6a0c9fe1"
};
export default firebaseConfig;